type PlaceholderDelayControls = {
	delete: () => Promise<void>;
	pause: () => Promise<void>;
	type: () => Promise<void>;
};

type RunPlaceholderCycleParams = {
	getCurrentToken: () => number;
	placeholderHints: string[];
	token: number;
	wait: PlaceholderDelayControls;
	writeAnimatedPlaceholder: (value: string) => void;
};

export const runPlaceholderCycle = async ({
	getCurrentToken,
	placeholderHints,
	token,
	wait,
	writeAnimatedPlaceholder
}: RunPlaceholderCycleParams) => {
	let hintIndex = 0;

	while (token === getCurrentToken()) {
		const currentHint = placeholderHints[hintIndex] ?? '';

		for (let index = 1; index <= currentHint.length; index += 1) {
			if (token !== getCurrentToken()) {
				return;
			}

			writeAnimatedPlaceholder(currentHint.slice(0, index));
			await wait.type();
		}

		if (token !== getCurrentToken()) {
			return;
		}

		await wait.pause();

		for (let index = currentHint.length - 1; index >= 0; index -= 1) {
			if (token !== getCurrentToken()) {
				return;
			}

			writeAnimatedPlaceholder(currentHint.slice(0, index));
			await wait.delete();
		}

		hintIndex = (hintIndex + 1) % placeholderHints.length;
	}
};
